import localDataFunctions from "@/localDataFunctions";
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";
import { type } from 'devexpress-dashboard/model/index.metadata';

export default {
  name: 'ConditionalFormatting',
  mixins: [localDataFunctions],
  components: {
    datetime: Datetime,
  },
  props: {
    displayDialog: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: null,
    },
    showRefreshRecordsButt: {
      type: Boolean,
      default: true
    },
    refName: {
      type: String,
      default: 'devExtremeGrid'
    },
    employeeStationId: {
      type: Number,
      default: -1
    },
    localSaveLocation: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      deleteType: '',
      activeTab: 'tab-condition',
      enableFormatting: this.getFromLocal(this.localSaveLocation + '_enableFormatting') ?? false,
      deleteDialog: false,
      showDialog: false,
      rulesList: this.getFromLocal(this.localSaveLocation) ?? [],
      selectedRule: {
        id: null,
        name: '',
        applyToColumn: '',//this.columns[0],
        condition: '',//this.conditions[0],
        value1: '',
        value2: '',
        format: '',
        priority: 1,
        formatIds: {
          color: '',
          background: '',
          decorations: []
        },
        isExpression: false,
        expression: {
          applyToColumn: '',
          condition: '',
          value1: '',
          value2: '',
          id: null,
          display: '',
        },
        expressionsList: [],
      },
      conditions: [
        { id:0 , text: this.$t('ConditionalFormatting.EqualsToValue1')},
        { id:1 , text: this.$t('ConditionalFormatting.IsNotEqualToValue1')},
        { id:2 , text: this.$t('ConditionalFormatting.StartsWithValue1')},
        { id:3 , text: this.$t('ConditionalFormatting.EndsWithValue1')},
        { id:4 , text: this.$t('ConditionalFormatting.ContainsValue1')},
        { id:5 , text: this.$t('ConditionalFormatting.IsGreaterThanValue1')},
        { id:6 , text: this.$t('ConditionalFormatting.IsGreaterThanOrEqualValue1')},
        { id:7 , text: this.$t('ConditionalFormatting.IsLessThanValue1')},
        { id:8 , text: this.$t('ConditionalFormatting.IsLessThanOrEqualToValue1')},
        { id:9 , text: this.$t('ConditionalFormatting.IsBetweenValue1AndValue2')},
        { id: 10, text: this.$t('ConditionalFormatting.IsNotBetweenValue1AndValue2') },
        { id: 11, text: this.$t('ConditionalFormatting.NotEmpty') },
      ],
      backgroundFormats: [
        { id: 0, text: this.$t('ConditionalFormatting.Red'), value: 'background-red', textClass: 'background-red color-white' , selected: false },
        { id: 1, text: this.$t('ConditionalFormatting.Green'), value: 'background-green', textClass: 'background-green color-white' , selected: false },
        { id: 2, text: this.$t('ConditionalFormatting.Blue'), value: 'background-blue-text', textClass: 'background-blue-text color-white' , selected: false },
        { id: 3, text: this.$t('ConditionalFormatting.Violet'), value: 'background-violet', textClass: 'background-violet color-white' , selected: false },
        { id: 4, text: this.$t('ConditionalFormatting.Brown'), value: 'background-brown', textClass: 'background-brown color-white' , selected: false },
        { id: 5, text: this.$t('ConditionalFormatting.Yellow'), value: 'background-dark-yellow', textClass: 'background-dark-yellow color-white' , selected: false },
        { id: 6, text: this.$t('ConditionalFormatting.Black'), value: 'background-black', textClass: 'background-black color-white' , selected: false },
        { id: 7, text: this.$t('ConditionalFormatting.Gray'), value: 'background-gray', textClass: 'background-gray color-white' , selected: false },
        { id: 8, text: this.$t('ConditionalFormatting.White'), value: 'background-white', textClass: 'background-white color-black' , selected: false },         
      ],
      colorFormats: [
        { id: 0, text: this.$t('ConditionalFormatting.Red'), value: 'color-red-text', textClass: 'color-red-text', selected: false },
        { id: 1, text: this.$t('ConditionalFormatting.Green'), value: 'color-green', textClass: 'color-green', selected: false },
        { id: 2, text: this.$t('ConditionalFormatting.Blue'), value: 'color-blue-text', textClass: 'color-blue-text', selected: false },
        { id: 3, text: this.$t('ConditionalFormatting.Violet'), value: 'color-violet', textClass: 'color-violet', selected: false },
        { id: 4, text: this.$t('ConditionalFormatting.Brown'), value: 'color-brown', textClass: 'color-brown', selected: false },
        { id: 5, text: this.$t('ConditionalFormatting.Yellow'), value: 'color-dark-yellow', textClass: 'color-dark-yellow', selected: false },
        { id: 6, text: this.$t('ConditionalFormatting.Black'), value: 'color-black', textClass: 'color-black white-checkbox', selected: false },
        { id: 7, text: this.$t('ConditionalFormatting.Gray'), value: 'color-gray', textClass: 'color-gray', selected: false },
        { id: 8, text: this.$t('ConditionalFormatting.White'), value: 'color-white', textClass: 'color-white background-black ', selected: false },
      ],
      textDecorations: [
        //{ id: 0, text: this.$t('ConditionalFormatting.Overline'), value: 'text-decoration-overline', selected: false  },
        { id: 0, text: this.$t('ConditionalFormatting.Underline'), value: 'text-decoration-underline', selected: false },
        { id: 1, text: this.$t('ConditionalFormatting.Strikeout'), value: 'text-decoration-line-through', selected: false },
        { id: 2, text: this.$t('ConditionalFormatting.Bold'), value: 'font-weight-bold', selected: false },
        { id: 3, text: this.$t('ConditionalFormatting.Italic'), value: 'font-style-italic', selected: false },
      ],
      selectBackgroundColorExp: false,
      selectTextColorExp: false,
      textDecorationsExp: false,
    }
  },
  computed: {
    prioritys: function () {
      let temp = [], i;
      for (i = 1; i < this.rulesList.length + 1; i++) 
        temp.push(i);

      if (this.selectedRule.id == null)
        temp.push(i);

      return temp.length > 0 ? temp : [1];
    },
    showDateForValues: function () {
      if (this.activeTab == 'tab-expression')
        return this.selectedRule.expression.applyToColumn && this.selectedRule.expression.applyToColumn.dataType != null && this.selectedRule.expression.applyToColumn.dataType == 'date';
      else
        return this.selectedRule.applyToColumn && this.selectedRule.applyToColumn.dataType != null && this.selectedRule.applyToColumn.dataType == 'date';
    },
    showTimeForValues: function () {
      if (this.activeTab == 'tab-expression')
        return this.selectedRule.expression.applyToColumn && this.selectedRule.expression.applyToColumn.dataField && this.selectedRule.expression.applyToColumn.evaluateAsTime;
      else
        return this.selectedRule.applyToColumn && this.selectedRule.applyToColumn.dataField && this.selectedRule.applyToColumn.evaluateAsTime;
    },
    finalConditions: function () {
      if (this.activeTab == 'tab-condition')
        return this.showTimeForValues || this.showDateForValues ? this.conditions.filter(c => c.id != 2 && c.id != 3 && c.id != 4) : this.conditions;
      else
        return this.conditions.filter(c => c.id != 9 && c.id != 10);
    },
    deleteText: function () {
      if (this.deleteType == 'rule')
        return `${this.$t('ConditionalFormatting.DeleteConfrirmation')} ${this.$t('ConditionalFormatting.DeleteConfrirmationRule')} "${this.selectedRule.name}"?`;
      else {
        let text, temp;
        if (this.selectedRule.expressionsList.length == 1)
          text = this.selectedRule.expressionsList[0].display;

        if (this.selectedRule.expressionsList.length == 2)
          text = this.selectedRule.expressionsList[1].condition.text;

        if (this.selectedRule.expressionsList.length == 3) {
          temp = this.selectedRule.expressionsList[2].display.split(text = this.selectedRule.expressionsList[1].condition.text);
          text = temp[temp.length - 1];
        }

        text = text ? text.trim() : '';

       return `${this.$t('ConditionalFormatting.DeleteConfrirmation')} ${this.$t('ConditionalFormatting.DeleteConfrirmationExpression')} "${text}"?`;
      }
    },
    disableAndOrButtons: function () {
      return !this.selectedRule.expressionsList || this.selectedRule.expressionsList.length == 0 || this.selectedRule.expressionsList.length != 1;
    },
    disbaleDeleteExprButton: function () {
      return this.selectedRule.expressionsList && this.selectedRule.expressionsList.length == 0;
    },
  },
  mounted() {
    this.closeDialog(this.autoApplyRules);
  },
  methods: {
    tabChanged(item) {
      this.activeTab = item;
      this.selectedRule.isExpression = item == 'tab-expression';
    },
    isSelected(rule, type) {
      if (type == 'expression')
        return this.selectedRule && this.selectedRule.expression.id == rule.id ? 'background-light-blue_wached ' : '';
      else
        return this.selectedRule && this.selectedRule.id == rule.id ? 'background-light-blue_wached ' : '';
    },
    formatSelected(item) {
      this.selectedRule = { ...item };
    },
    isFormatSelected(rule) {
      return this.selectedRule && this.selectedRule.id == rule.id ? 'background-light-blue_wached ' : '';
    },
    newRule(item) {
      if (item) {
        this.selectedRule = { ...item };
        if(this.selectedRule.isExpression) 
          this.selectedRule.expression.display = this.selectedRule.expressionsList.length == 0 ? '' : this.selectedRule.expressionsList[this.selectedRule.expressionsList.length - 1]['display'];
      }
      else {
        this.selectedRule = {
          id: null,
          name: '',
          applyToColumn: '',//this.columns[0],
          condition: '',//this.conditions[0],
          value1: '',
          value2: '',
          format: '',
          priority: this.rulesList.length + 1,
          formatIds: {
            color: '',
            background: '',
            decorations: []
          },
          isExpression: false,
          expression: {
            applyToColumn: '',
            condition: '',
            value1: '',
            display: '',
          },
          expressionsList: [],
        }
      }

      this.activeTab = this.selectedRule.isExpression ? 'tab-expression' : 'tab-condition';

      this.textDecorations.forEach(f => {
        if (this.selectedRule.formatIds.decorations.includes(f.id) && item != null)
          f.selected = true;
        else
          f.selected = false;
      });

      this.colorFormats.forEach(f => {
        if (this.selectedRule.formatIds.color == f.id && item != null)
          f.selected = true;
        else
          f.selected = false;
      });

      this.backgroundFormats.forEach(f => {
        if (this.selectedRule.formatIds.background == f.id && item != null)
          f.selected = true;
        else
          f.selected = false;
      });      

      this.selectBackgroundColorExp = false;
      this.selectTextColorExp = false;
      this.textDecorationsExp = false;
    },
    ruleCheck(rule, isExpression = false) {
      if (!rule.applyToColumn || !rule.applyToColumn.dataField && !isExpression) {
        this.$oldAlertMsg(this.$t('ConditionalFormatting.ApplyError'), 3);
        return false;
      }

      if (!rule.condition || rule.condition.id == null || rule.condition.id < 0) {
        this.$oldAlertMsg(this.$t('ConditionalFormatting.ConditionError'), 3);
        return false;
      }

      if (isExpression) {
        if (rule.value1 == null || rule.value1 == '') {
          this.$oldAlertMsg(this.$t('ConditionalFormatting.Value1Error'), 3);
          return false;
        }
      }
      else {
        if (rule.value1 == null || rule.value1 == '') {
          this.$oldAlertMsg(this.$t('ConditionalFormatting.Value1Error'), 3);
          return false;
        }

        if ((rule.condition.id == 9 || rule.condition.id == 10) && (rule.value2 == null || rule.value2 == '')) {
          this.$oldAlertMsg(this.$t('ConditionalFormatting.Value2Error'), 3);
          return false;
        }
      }

      return true;
    },
    saveRule(applyRules = false) {
      if (this.selectedRule.id == null && applyRules) {
        this.enableFormatting = true;
        this.closeDialog();
      }

      //CHECKS
      if (!this.selectedRule.name)
        this.selectedRule.name = 'Rule' + this.rulesList.length;

      if (!this.selectedRule.isExpression && !this.ruleCheck(this.selectedRule)) {
        return;
      }
      else if (this.selectedRule.isExpression) {
        if (!this.selectedRule.expressionsList || this.selectedRule.expressionsList.length == 0 || this.selectedRule.expressionsList.length == 2) {
          this.$oldAlertMsg(this.$t('ConditionalFormatting.ExpressionMissingError'), 3);
          return;
        }
      }

      //Formatting checks
      if (this.colorFormats.every(c => c.selected == false) && this.backgroundFormats.every(c => c.selected == false) &&
        this.textDecorations.every(c => c.selected == false)) {
        this.$oldAlertMsg(this.$t('ConditionalFormatting.FormattingError'), 3);
        return;
      }

      //create formatting - save format ids
      this.selectedRule.formatIds.decorations = [];
      this.selectedRule.format = '';

      let temp = this.colorFormats.filter(f => f.selected == true);
      if (temp && temp.length > 0) {
        this.selectedRule.formatIds.color = temp[0].id;
        this.selectedRule.format = temp[0].value;
      }      

      temp = this.backgroundFormats.filter(f => f.selected == true);
      if (temp && temp.length > 0) {
        this.selectedRule.formatIds.background = temp[0].id;
        this.selectedRule.format = temp[0].value + ' ' + this.selectedRule.format;
      }

      this.textDecorations.forEach(f => {
        if (f.selected == true) {
          this.selectedRule.formatIds.decorations.push(f.id);
          this.selectedRule.format = f.value + ' ' + this.selectedRule.format;
        }
      });

      //check priority      
      let priorityIndex = this.rulesList && this.rulesList.length > 0 ? this.rulesList.findIndex(r => r.priority == this.selectedRule.priority) : -1;

        if (priorityIndex > -1)
          this.rulesList[priorityIndex].priority = this.rulesList.length + 2;      

      //align data for expressions
      if (this.selectedRule.isExpression) {
        this.selectedRule.applyToColumn = '';
        this.selectedRule.condition = '';
        this.selectedRule.value1 = '';
        this.selectedRule.value2 = '';

        this.selectedRule.expression.applyToColumn = '';
        this.selectedRule.expression.condition = '';
        this.selectedRule.expression.value1 = '';
        this.selectedRule.expression.value2 = '';
        this.selectedRule.expression.display = '';
      }

      let index = this.rulesList && this.rulesList.length > 0 ? this.rulesList.findIndex(r => this.selectedRule.id == r.id) : -1;
      if (index > -1) {
        //editing rule
        if (priorityIndex > -1) //conflic in priority
          this.rulesList[priorityIndex].priority = index + 1;

        this.rulesList[index] = { ...this.selectedRule };
      }
      else {
        //new rule
        if (priorityIndex > -1) //conflic in priority
          this.rulesList[priorityIndex].priority = this.rulesList.length + 1;

        let id = 0;
        if (this.rulesList.length > 0)
          id = Math.max(... this.rulesList.map(r => r.id)) + 1;

        this.selectedRule['id'] = id;
        this.rulesList.push({ ...this.selectedRule });
      }


      this.rulesList.sort((a, b) => a.priority - b.priority);

      this.saveToLocal(this.localSaveLocation, this.rulesList);

      this.$oldAlertMsg(this.$t('ConditionalFormatting.RuleSaved'), 2);

      this.enableFormatting = true;

      if (applyRules)
        this.closeDialog();
      else {
        this.newRule();
        this.$emit('apply-rules', this.rulesList);
      }
    },

    deleteInit(type) {
      if (!this.selectedRule || this.selectedRule.id == null || this.selectedRule.id < 0)
        return;

      this.deleteType = type;
      this.deleteDialog = true;
    },
    deleteRule() {
      if (this.deleteType == 'Rule') {
        let priority = this.selectedRule.priority;

        const arr = this.rulesList.filter(object => object.id != this.selectedRule.id);

        if (arr && arr.length > 0)
          this.rulesList = [...arr];
        else
          this.rulesList = [];

        //fix priority after delete
        this.rulesList.forEach(r => {
          if (r.priority > priority)
            r.priority--;
        });

        this.saveToLocal(this.localSaveLocation, this.rulesList);
        this.newRule();
      }
      else if (this.deleteType == 'Expression') {
        this.selectedRule.expressionsList.pop();
        this.selectedRule.expression.display = this.selectedRule.expressionsList.length > 0 ? this.selectedRule.expressionsList[this.selectedRule.expressionsList.length - 1].display : '';

        //initialize with poped element
        this.selectedRule.expression.applyToColumn = '';
        this.selectedRule.expression.condition = '';
        this.selectedRule.expression.value1 = '';
        this.selectedRule.expression.value2 = '';      
      }

      this.$oldAlertMsg(`${this.$t('ConditionalFormatting.' + this.deleteType)} ${this.$t('ConditionalFormatting.Deleted')}`, 2);
      this.deleteType = '';
    },

    formatingSelected(item,type, isCheckbox) {
      //console.log("colorSelected item", item);

      if (!isCheckbox) {
        item.selected = !item.selected;
      }

      if (type == 'color') {
        this.colorFormats.forEach(f => {
          if (f.id != item.id)
            f.selected = false;
        });

        this.selectTextColorExp = false;
        this.selectBackgroundColorExp = true;
      }      
      else if (type == 'background') {
        this.backgroundFormats.forEach(f => {
          if (f.id != item.id)
            f.selected = false;
        });

        this.selectBackgroundColorExp = false;
        this.textDecorationsExp = true;
      }     
      else if (type == 'decoration') {
        //underline
        if (item.id == 0 && this.textDecorations[1].selected)
            this.textDecorations[1].selected = false;

      //strikeout
      if (item.id == 1 && this.textDecorations[0].selected)
        this.textDecorations[0].selected = false;
      }
    },

    rulesAppliesToSelected(item) {
      this.selectedRule.value1 = '';
      this.selectedRule.value2 = '';
      this.selectedRule.condition = '';

      this.selectedRule.value1 = '';
      this.selectedRule.expression.value2 = '';
      this.selectedRule.expression.condition = '' 
    },
    enableRulesChanged(value) {
      this.saveToLocal(this.localSaveLocation + '_enableFormatting', this.enableFormatting);

      if (value)
        this.$emit('apply-rules', this.rulesList);
      else
        this.$emit('apply-rules', []);
    },
    exprValueForDisplay() {
      if (this.selectedRule.expression && this.selectedRule.expression.applyToColumn && this.selectedRule.expression.applyToColumn.dataType
        && this.selectedRule.expression.applyToColumn.dataType == 'date') {
        return this.$options.filters.formatDateDDMMYYY(this.selectedRule.expression.value1);
      }

      if (this.selectedRule.expression && this.selectedRule.expression.applyToColumn && this.selectedRule.expression.applyToColumn.evaluateAsTime) {
        return this.$options.filters.formatDateHHmm(this.selectedRule.expression.value1);
      }

      return this.selectedRule.expression.value1;
    },
    addExpression(andOr, reset = true) {
      let description = '';

      if (!andOr) {
        if (!this.ruleCheck(this.selectedRule.expression, true)) {
          return;
        }

        //if user add expression without END/OR
        if (this.selectedRule.expressionsList.length == 1) {
          description = '\n' + this.$t(`ConditionalFormatting.And`) + '\n';

          this.selectedRule.expressionsList.push({
            condition: { id: 101, text: this.$t('ConditionalFormatting.And') },
            display: `${this.selectedRule.expression.display} ${description}`,
            applyToCoumn: '',
            value1: '',
            value2: '',
          });
        }

        if (this.selectedRule.expression.condition.id == 11)
          description = `${description ?? ''} ${this.selectedRule.expression.condition.text} [${this.selectedRule.expression.applyToColumn.caption}]`;
        else
          description = `${description ?? '' } [${this.selectedRule.expression.applyToColumn.caption}] ${this.selectedRule.expression.condition.text.replace('[Value1]', '') ?? this.selectedRule.expression.condition.text} [${this.exprValueForDisplay()}]`;
      }
      else {
        description = '\n' + this.$t(`ConditionalFormatting.${andOr}`) + '\n';
        let cond = andOr == 'Or' ? { id: 102, text: this.$t('ConditionalFormatting.Or') } : { id: 101, text: this.$t('ConditionalFormatting.And') };
        this.selectedRule.expression.condition = { ...cond };
      }

      this.selectedRule.expression.display = `${this.selectedRule.expression.display} ${description}`;
      this.selectedRule.expressionsList.push({ ...this.selectedRule.expression });

      if (reset) {
        this.selectedRule.expression.applyToColumn = '';
        this.selectedRule.expression.condition = '';
        this.selectedRule.expression.value1 = '';
        this.selectedRule.expression.value2 = '';
      }
    },

    showFormatDialog() {
      this.newRule();
      this.showDialog = true;
    },
    closeDialog(emit = true) {
      this.newRule();
      this.showDialog = false;

      if (emit && this.enableFormatting)
        this.$emit('apply-rules', this.rulesList);
    },
  }
}
